<template>
    <carousel 
      :perPage="1" 
      :autoplay="true" 
      :autoplayTimeout="2000"
      :paginationEnabled="false"
      :loop="true"
    >
      <slide v-for="(banner, index) in banners" :key="index">
        <div :class="{ 'bg-image': bgImg }" 
          :style="{ 
            'background': 'url('+banner.url+')',
            'background-repeat': 'no-repeat',
            'background-position': 'center center',
            'background-size': 'cover',
            'background-attachment': 'inherit'
          }"></div>
      </slide>  
    </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { db } from "../main"

export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      bgImg: true,
      banners: [
        {
          url: require('../assets/banners/b1.jpg')
        },
        {
          url: require('../assets/banners/b2.jpg')
        }
      ]
    }
  },
  // firestore(){
  //   return {
  //     banners: db.collection('banners')
  //   }
  // }
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100vh;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue